import React from 'react'
import PropTypes from 'prop-types'
import { HOSTS, PROTOCOL, getHostKey } from '../lib/helper'
import Input from './input'

const TokenInput = (props) => {
	const { error, toggleForm, className, value, required = false, moreInfo, name, protocol, placeholder, title, formType } = props

	const canToggleOption = () => {
		return ![HOSTS.ELEMENTOR, HOSTS.AUTOMATTIC].includes(formType)
	}

	return <div>
		<p className="pt-1 pb-2 mb-2 fw-600 text-right bv-underline">
			{ canToggleOption() ? <a onClick={toggleForm}>Manually Input Host Details</a> : null }
		</p>
		{ error && <div className="pb-2 mb-2 font12">{error}</div> }
		<div className="row">
			<div className={className}>
				<i className="mdi mdi-key"></i>
				{moreInfo}
				<Input
					type="text"
					name={name}
					title={title}
					placeholder={placeholder || "Eg. 6LU9ECHXP7UTMZ8V"}
					classname=""
					required={required}
					value={value}
				/>
			</div>
		</div>
		<div className="row hide-field">
			<Input
				type="hidden"
				title=""
				name="protocol"
				placeholder=""
				classname=""
				value={protocol || PROTOCOL.TOKEN}
			/>
			<Input
				type="hidden"
				name="migrate"
				value={getHostKey(formType)}
				title=""
				placeholder=""
				classname=""
			/>
		</div>
	</div>
}

TokenInput.propTypes = {
	error: PropTypes.string,
	toggleForm: PropTypes.func,
	className: PropTypes.string,
	value: PropTypes.string,
	moreInfo: PropTypes.element,
	required: PropTypes.bool,
	name: PropTypes.string,
	placeholder: PropTypes.string,
	title: PropTypes.string,
	protocol: PropTypes.number
}

export default TokenInput
